module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_11-d48f51e7d41fb0163dd58b18dba16b2e.png";